import React from "react";
import {
  GridActionsCellItem,
  getGridSingleSelectOperators,
} from "@mui/x-data-grid-pro";
import { Tooltip } from "@mui/material";
import commonUtils from "../../../helpers/commonUtils";
const getAction = (params, localization, handleActionButtons) => {
  const _acionList = [];
  if (params.row.isLocked && params.row.aktiv.toLowerCase() === "j") {
    _acionList.push(
      <GridActionsCellItem
        label={localization.deActivate}
        showInMenu
        onClick={() => handleActionButtons("Deactivate", params.row)}
      />,
    );
  }
  if (!params.row.isLocked) {
    _acionList.push(
      <GridActionsCellItem
        label={localization.publishChecklist}
        showInMenu
        onClick={() => handleActionButtons("Publish", params.row)}
      />,
    );
  }
  if (!params.row.isLocked) {
    _acionList.push(
      <GridActionsCellItem
        label={localization.deleteChecklist}
        showInMenu
        onClick={() => handleActionButtons("Delete", params.row)}
      />,
    );
  }
  if (
    (commonUtils.isUserOrganisationAdmin() || commonUtils.isUserWerkAdmin()) &&
    params.row.isLocked
  ) {
    _acionList.push(
      <GridActionsCellItem
        label={localization.saveAsTemplate}
        showInMenu
        onClick={() => handleActionButtons("SaveAsTemplate", params.row)}
      />,
    );
  }
  _acionList.push(
    <GridActionsCellItem
      data-toggle="modal"
      data-target="#addDigitalChecklist"
      label={localization.toolTipEdit}
      showInMenu
      onClick={() => handleActionButtons("Edit", params.row)}
    />,
  );
  return _acionList;
};
const getActionInnerTable = (params, localization, handleActionButtons) => {
  const _acionList = [];
  if (params.row.aktiv.toLowerCase() == "n") {
    _acionList.push(
      <GridActionsCellItem
        data-toggle="modal"
        data-target="#addDigitalChecklist"
        label={localization.viewDetails}
        showInMenu
        onClick={() => handleActionButtons("view", params.row)}
      />,
    );
  }
  if (params.row.aktiv.toLowerCase() == "j") {
    _acionList.push(
      <GridActionsCellItem
        data-toggle="modal"
        data-target="#addDigitalChecklist"
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => {
          handleActionButtons("Edit", params.row);
        }}
      />,
    );
  }
  if (params.row.isLocked && params.row.aktiv.toLowerCase() === "j") {
    _acionList.push(
      <GridActionsCellItem
        label={localization.deActivate}
        showInMenu
        onClick={() => {
          handleActionButtons("Deactivate", params.row);
        }}
      />,
    );
  }
  if (!params.row.isLocked) {
    _acionList.push(
      <GridActionsCellItem
        label={localization.publishChecklist}
        showInMenu
        onClick={() => {
          handleActionButtons("Publish", params.row);
        }}
      />,
    );
  }
  if (!params.row.isLocked) {
    _acionList.push(
      <GridActionsCellItem
        label={localization.deleteChecklist}
        showInMenu
        onClick={() => {
          handleActionButtons("Delete", params.row);
        }}
      />,
    );
  }

  return _acionList;
};
export default function RenderColDef(localization, handleActionButtons) {
  return [
    {
      field: "title",
      headerName: localization.checklistTitle,
      width: 100,
      type: "string",

      renderCell: (params) => {
        const titleContent =
          !params.row.isLocked && params.row.aktiv ? (
            <>
              <span className="draftIconCls" title={localization.draft}>
                *
              </span>
              {params.row.title}
            </>
          ) : (
            params.row.title
          );

        return (
          <Tooltip title={params.row.title}>
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {titleContent}
            </div>
          </Tooltip>
        );
      },

      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: localization.actions,
      width: 45,
      hideable: false,
      getActions: (params) => [
        ...getAction(params, localization, handleActionButtons),
      ],
    },
    {
      field: "checklistNr",
      headerName: localization.ChecklistNr,
      width: 100,
      type: "string",
      valueGetter: (params) => {
        return params.row.checklistNr;
      },
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "global",
      headerName: localization.global,
      valueGetter: (params) => {
        return params.row.anlagegruppeId ? localization.no : localization.yes;
      },
      filterOperators: getSelectionFilter(),
      type: "singleSelect",
      valueOptions: [
        { value: localization.yes, label: localization.yes },
        { value: localization.no, label: localization.no },
      ],
      width: 50,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "anlagegruppe",
      type: "string",
      headerName: localization.equipmentGroupNameCheckList,
      width: 100,
      valueGetter: (params) => {
        return params.row.anlagegruppe;
      },
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "wekId",
      type: "string",
      headerName: localization.plantid,
      width: 100,
      valueGetter: (params) => {
        return params.row.werkId;
      },
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "testGroup",
      type: "string",
      headerName: localization.testGroup,
      width: 100,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      type: "string",
      field: "kostGroup",
      headerName: localization.costCenterGroup,
      width: 100,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },

    {
      field: "publish",
      type: "singleSelect",
      headerName: localization.isPublished,
      valueGetter: (params) => {
        return params.row.isLocked ? localization.yes : localization.no;
      },
      renderCell: (params) => {
        return params.row.isLocked ? (
          <span className="badge badge-success rounded-pill d-inline badgeCls">
            {localization.yes}
          </span>
        ) : (
          <span className="badge badge-danger rounded-pill d-inline badgeCls">
            {localization.no}
          </span>
        );
      },
      filterOperators: getSelectionFilter(),
      valueOptions: [
        { value: localization.yes, label: localization.yes },
        { value: localization.no, label: localization.no },
      ],
      width: 100,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "active",
      headerName: localization.isActive,
      type: "singleSelect",
      valueGetter: (params) => {
        return params.row.aktiv === "J" ? localization.yes : localization.no;
      },
      filterOperators: getSelectionFilter(),
      valueOptions: [
        { value: localization.yes, label: localization.yes },
        { value: localization.no, label: localization.no },
      ],
      renderCell: (params) => {
        return params.row.aktiv === "J" ? (
          <span className="badge badge-success rounded-pill d-inline badgeCls">
            {localization.yes}
          </span>
        ) : (
          <span className="badge badge-danger rounded-pill d-inline badgeCls">
            {localization.no}
          </span>
        );
      },
      width: 100,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "hasDraft",

      headerName: localization.hasDraft,
      valueGetter: (params) => {
        let hasDraft = false;
        if (params.row.allVersions.length > 0) {
          hasDraft = params.row.allVersions.some(
            (item) => !item.isLocked && item.aktiv,
          );
        } else {
          hasDraft =
            !params.row.highestVersionChecklist.isLocked &&
            params.row.highestVersionChecklist.aktiv;
        }
        return hasDraft ? localization.yes : localization.no;
      },
      width: 50,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "version",

      headerName: localization.version,
      width: 50,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "frequency",
      headerName: localization.frequenz,
      valueGetter: (params) => {
        const { frequency, duration } = params.row;

        if (frequency && frequency !== "A" && duration > 0) {
          const unit =
            frequency === "M"
              ? localization.month
              : frequency === "Y"
                ? localization.year
                : localization.day;

          return `${localization.every} ${duration} ${unit}`;
        } else if (frequency === "A") {
          return localization.anytime;
        }
      },
      width: 100,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    ,
  ];
}

export function RenderInnerTableColDef(localization, handleActionButtons) {
  return [
    {
      field: "title",
      headerName: localization.checklistTitle,

      type: "string",
      renderCell: (params) => {
        const titleContent =
          !params.row.isLocked && params.row.aktiv ? (
            <>
              <span className="draftIconCls" title={localization.draft}>
                *
              </span>
              {params.row.title}
            </>
          ) : (
            params.row.title
          );

        return (
          <Tooltip title={params.row.title}>
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {titleContent}
            </div>
          </Tooltip>
        );
      },
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: localization.actions,
      width: 45,
      hideable: false,
      getActions: (params) => [
        ...getActionInnerTable(params, localization, handleActionButtons),
      ],
    },
    {
      field: "checklistNr",
      headerName: localization.ChecklistNr,

      type: "string",
      valueGetter: (params) => {
        return params.row.checklistNr;
      },
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "global",
      headerName: localization.global,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
      valueGetter: (params) => {
        return params.row.anlagegruppeId ? localization.no : localization.yes;
      },
    },

    {
      field: "publish",

      headerName: localization.isPublished,
      valueGetter: (params) => {
        return params.row.isLocked ? localization.yes : localization.no;
      },
      renderCell: (params) => {
        return params.row.isLocked ? (
          <span className="badge badge-success rounded-pill d-inline badgeCls">
            {localization.yes}
          </span>
        ) : (
          <span className="badge badge-danger rounded-pill d-inline badgeCls">
            {localization.no}
          </span>
        );
      },

      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "active",

      headerName: localization.isActive,
      valueGetter: (params) => {
        return params.row.aktiv === "J" ? localization.yes : localization.no;
      },
      renderCell: (params) => {
        return params.row.aktiv === "J" ? (
          <span className="badge badge-success rounded-pill d-inline badgeCls">
            {localization.yes}
          </span>
        ) : (
          <span className="badge badge-danger rounded-pill d-inline badgeCls">
            {localization.no}
          </span>
        );
      },
    },

    {
      field: "version",

      headerName: localization.version,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },

    ,
  ];
}

function getSelectionFilter() {
  return getGridSingleSelectOperators().filter(
    (operator) =>
      !["isnotempty", "isanyof", "not"].includes(operator.value.toLowerCase()),
  );
}
